import { v4 as uuidv4 } from 'uuid';

export default [
    {
        idSoft: uuidv4(),
        name: 'PORTRAIT',
        text: "Portrait",
        width: -1,
        height: 1,
    },
    {
        idSoft: uuidv4(),
        name: 'LANDSCAPE',
        text: "Paysage",
        width: 1,
        height: -1,
    },
]
